import { isValidPhoneNumber, parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Validates a phone number. Accepts E.164 format ("+61412345678") or a
 * national number when `countryCode` (ISO 3166-1 alpha-2) is provided.
 */
export const validatePhone = (value, countryCode) => {
  if (!value) return "";
  try {
    if (isValidPhoneNumber(value, countryCode)) {
      return "";
    }

    const parsed = parsePhoneNumberFromString(value, countryCode);
    if (parsed && parsed.country) {
      const countryName =
        new Intl.DisplayNames(["en"], { type: "region" }).of(parsed.country) ??
        parsed.country;
      return `Invalid phone number for ${countryName}`;
    }
  } catch {
    // fall through to generic message
  }
  return "Please enter a valid phone number";
};

// These characters break downstream POS handling of dish names (OA-1580),
// so Name and Alt Name reject them when a menu item is created or updated.
const MENU_ITEM_NAME_INVALID_CHARS = /[$#%;,]/;

export const validateMenuItemName = (value) => {
  if (!value) return "";
  if (MENU_ITEM_NAME_INVALID_CHARS.test(value)) {
    return "Cannot contain $, #, %, ; or ,";
  }
  return "";
};

export const validateEmail = (value) => {
  if (!value) return "";
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(value)) {
    return "Please enter a valid email address";
  }
  return "";
};
